'use strict';

var getCookieValue = require('../util/cookie');
var utils = require('../utils');
var endpoint = $('#suggestions-wrapper').data('url');
var minChars = 3;

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
    return $(scope).closest('form#simpleSearch').find('#suggestions-wrapper');
}

/**
 * Determines whether DOM element is inside the .search-mobile class
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 * @return {boolean} - Whether DOM element is inside  div.search-mobile
 */
function isMobileSearch(scope) {
    return !!$(scope).closest('.search-mobile').length;
}

/**
 * Remove modal classes needed for mobile suggestions
 *
 */
function clearModals() {
    $('body').removeClass('modal-open');
    $('.suggestions').removeClass('modal');
}

/**
 * Apply modal classes needed for mobile suggestions
 *
 * @param {Object} scope - Search input field DOM element
 */
function applyModals(scope) {
    if (isMobileSearch(scope)) {
        $('body').addClass('modal-open');
        getSuggestionsWrapper(scope).find('.suggestions').addClass('modal');
    }
}

/**
 * Tear down Suggestions panel
 */
function tearDownSuggestions() {
    $('input.search-field').val('');
    clearModals();
    $('.search-mobile .suggestions').unbind('scroll');
    $('#suggestions-wrapper').empty();
}

/**
 * Toggle search field icon from search to close and vice-versa
 *
 * @param {string} action - Action to toggle to
 */
function toggleSuggestionsIcon(action) {
    var mobileSearchIcon = '.search-mobile span.';
    var iconSearch = 'fa-search';
    var iconSearchClose = 'fa-close';

    if (action === 'close') {
        $(mobileSearchIcon + iconSearch)
            .removeClass(iconSearch)
            .addClass(iconSearchClose);
    } else {
        $(mobileSearchIcon + iconSearchClose)
            .removeClass(iconSearchClose)
            .addClass(iconSearch);
    }
}

/**
 * Determines whether the 'More Content Below' icon should be displayed
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function handleMoreContentBelowIcon(scope) {
    if (
        $(scope).scrollTop() + $(scope).innerHeight() >=
        $(scope)[0].scrollHeight
    ) {
        $('.more-below').fadeOut();
    } else {
        $('.more-below').fadeIn();
    }
}

/**
 * Positions Suggestions panel on page
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function positionSuggestions(scope) {
    var outerHeight;
    var $scope;
    var $suggestions;
    var top;

    if (isMobileSearch(scope)) {
        $scope = $(scope);
        top = $scope.offset().top;
        outerHeight = $scope.outerHeight();
        $suggestions = getSuggestionsWrapper(scope).find('.suggestions');
        $suggestions.css('top', top + outerHeight);

        handleMoreContentBelowIcon(scope);

        // Unfortunately, we have to bind this dynamically, as the live scroll event was not
        // properly detecting dynamic suggestions element's scroll event
        $suggestions.scroll(function () {
            handleMoreContentBelowIcon(this);
        });
    }
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    var $suggestionsWrapper = getSuggestionsWrapper(this).empty();

    if (!(typeof response === 'object')) {
        $suggestionsWrapper.append(response).show();
        positionSuggestions(this);

        if (isMobileSearch(this)) {
            toggleSuggestionsIcon('close');
            applyModals(this);
        }

        let noReseultFound = $('#suggestion-redesign');
        let searchResultValue = $('#simpleSearch .check-none:not(.d-none)')
            .find('.search-field')
            .val();
        let seperator = $('#suggestion-redesign .border-line');
        let isMobileView = utils.mediaBreakpointDown('sm');

        let noResult = noReseultFound.find('.no-result');
        noResult.append('<span>' + searchResultValue + '</span>');
        if (isMobileView) {
            seperator.removeClass('d-none');
        }

        if (noResult.length !== 0) {
            seperator.addClass('d-none');
        }
        $('div#searchRedesignTemplate .input-group').addClass(
            'input-group-focus-within'
        );
    } else {
        $('div#searchRedesignTemplate .input-group').removeClass(
            'input-group-focus-within'
        );
        $suggestionsWrapper.hide();
    }
}
var onCancelClick = () => {
    let seperator = $('#suggestion-redesign .border-line');
    let searchResultValue = $('#simpleSearch .check-none:not(.d-none)').find(
        '.search-field'
    );

    $('#header-redesign').removeClass('header-redesign-mobile');
    seperator.addClass('d-none');
    searchResultValue.val('');
    $('div#searchRedesignTemplate .input-group').removeClass(
        'input-group-focus-within'
    );
};
/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    let cancelButton = $('.cancel-button');
    $(document).on('cancel-search', onCancelClick);
    cancelButton.click(onCancelClick);
    minChars = 1;

    if ($(scope).val() && $(scope).val().length >= minChars) {
        endpoint = $(scope).closest('form').find('#suggestions-wrapper').data('url') || endpoint;
        var url = endpoint + encodeURIComponent($(scope).val());

        if ($('.web-in-store-banner').length) {
            url += '&wis=1';
        }

        url += '&headerRedesign=true&hitSuggestion=true';

        $.ajax({
            context: scope,
            url: url,
            method: 'GET',
            success: processResponse,
            error: function () {
                $.spinner().stop();
            }
        });
    } else {
        toggleSuggestionsIcon('search');
        clearModals();
        getSuggestionsWrapper(scope).empty();
        $('div#searchRedesignTemplate .input-group').removeClass(
            'input-group-focus-within'
        );
    }
}

/**
 * Search template redesign
 *
 * @param {Object} scope - Header sticky when header redesign is true
 */
function stickyNav() {
    let $pdpRedesignFlag = $('#product-detail-redesign');
    let $giftcardRedesign = $('#gift-card-redesign');
    let headerRedesignVal = 'headerRedesign';
    let headerRedesignCookie = getCookieValue.get(headerRedesignVal);
    let $mainHeaderContainer = $('#main-header-container');
    let $stickyDiv = 'sticky-header-redesign';
    let $filterHeaderAlign = $('.refinement-bar');
    let $filterDiv = 'filter-header-redesign';
    let $purLandingSelector = $('#container-pur-redesign');

    if (
        (headerRedesignCookie && headerRedesignCookie === true) ||
        $('#headerRedesignVal').val() === 'true'
    ) {
        // Sticky header not applicable for pdp and giftcard page
        if (
            !(
                utils.mediaBreakpointDown('sm') &&
                $pdpRedesignFlag &&
                $pdpRedesignFlag.length !== 0
            ) &&
            (!$giftcardRedesign || $giftcardRedesign.length === 0) &&
            (!$purLandingSelector || $purLandingSelector.length === 0)
        ) {
            $mainHeaderContainer.addClass($stickyDiv);
            $filterHeaderAlign.addClass($filterDiv);
        } else {
            $mainHeaderContainer.removeClass($stickyDiv);
            $mainHeaderContainer.addClass('new-pdp-header');
        }
    }
}

/**
 * Click functionality on redesigned search bar in mobile
 *
 * @param {Object} scope - Search field DOM element redesign
 */
function onSearchBarClickInMobile() {
    let searchField = $('#simpleSearch .search-field');

    if ($('#headerRedesignVal').val() === 'true') {
        searchField.click(function () {
            $(this).addClass('search-field-expanded');
        });
    }
}

module.exports = function () {
    onSearchBarClickInMobile();
    stickyNav();
    $('input.search-field').each(function () {
        $(this).on('keyup click', function (e) {
            // Load Suggestion CSS after keyup
            // Ignore enter and arrow keys
            if (e.which !== 13 && e.which !== 37 && e.which !== 38 && e.which !== 39 && e.which !== 40) {
                $('body').trigger('product:beforeSuggestionsLoads');
                getSuggestions(this, e);
            }
        });
    });

    var hideSuggestion = (e) => {
        if (
            !$('.suggestions').has(e.target).length &&
            !$(e.target).hasClass('search-field')
        ) {
            $('.suggestions').hide();
            $('div#searchRedesignTemplate .input-group').removeClass(
                'input-group-focus-within'
            );
            $('.cancel-button').hide();
        }
    };
    $(document).on('hide-suggestion', hideSuggestion);
    $('body').on('click', (e) => {
        hideSuggestion(e);
    });
    $('body').on('click touchend', '.search-mobile span.fa-close', function () {
        $('.suggestions').hide();
        toggleSuggestionsIcon('search');
        tearDownSuggestions();
        $('div#searchRedesignTemplate .input-group').removeClass(
            'input-group-focus-within'
        );
    });

    $('.cancel-button').on('click', function () {
        var queryData = $.trim(
            $('#searchRedesignTemplate').find('[name="q"]').val()
        );
        queryData = queryData.length ? queryData : 'No Keyword';
        $('body').trigger('search:cancel', { queryData: queryData });
        $('div#searchRedesignTemplate .input-group').removeClass(
            'input-group-focus-within'
        );
    });

    $('body').on(
        'click',
        '.product-suggestion, .suggestioncategory, .suggestionbrand, .js-product-search-link, .term',
        function () {
            $('div#searchRedesignTemplate .input-group').removeClass('input-group-focus-within');
            $('#suggestions-wrapper').hide();
            var queryData = $('#searchRedesignTemplate')
                .find('[name="q"]')
                .val();
            queryData = $.trim(queryData);
            var suggestProd = $(this).hasClass('product-suggestion');
            var prodName = $(this).find('.js-prodname').text();
            var prodPlatform = $(this).find('.js-prodplatform').text();
            var suggestionItem = $(this).find('.js-suggestionitem').text();
            var suggestResult = suggestProd
                ? $.trim(prodName + ' ' + prodPlatform)
                : $.trim(suggestionItem);
            var headerText = $(this).parent().siblings('.header').text();
            var resultVal = headerText
                ? $.trim(headerText) + '|' + suggestResult
                : suggestResult;
            var searchCategory = $.trim(
                $(this).parent().siblings('.header').text()
            );
            var searchQueryData = {
                queryData: queryData,
                suggestResult: suggestResult,
                eventLabel: 'autocomplete',
                experienceType: 'search autocomplete'
            };
            sessionStorage.setItem(
                'searchQueryData',
                JSON.stringify(searchQueryData)
            );

            $('body').trigger('search:suggestion', {
                queryData: queryData,
                resultVal: resultVal,
                eventLabel: 'autocomplete',
                searchCategory: searchCategory,
                suggestResult: suggestResult
            });
        }
    );

    $('#simpleSearch').on('submit', function () {
        $('.js-search-input').trigger('blur');
        var $form = $(this);
        var resultVal;
        var $query = $form.find('[name="q"]');
        let $redesignTemplate = $form.find('#searchRedesignTemplate');
        if (!$redesignTemplate.hasClass('d-none')) {
            $query = $redesignTemplate.find('[name="q"]');
            var queryVal = $.trim($query.val());
            if ($('#suggestion-redesign').find('.no-result').length) {
                resultVal = 'nullSearch';
            } else {
                resultVal = 'searchClick';
            }
            var searchQueryData = {
                queryData: queryVal,
                suggestResult: '',
                eventLabel: 'user input',
                experienceType: ''
            };
            sessionStorage.setItem(
                'searchQueryData',
                JSON.stringify(searchQueryData)
            );

            $('body').trigger('search:suggestion', {
                queryData: queryVal,
                resultVal: resultVal,
                eventLabel: 'user input',
                searchCategory: '',
                suggestResult: ''
            });
        }

        if (!$query.val()) {
            $query.addClass('is-invalid').focus();
            $('#simpleSearch .search-field').trigger('click');
            return false;
        }
        return true;
    });
};

$(document).ready(function () {
    let $searchField = $('#simpleSearch .search-field');
    let $cancelButton = $('.cancel-button');
    $searchField.focus(function () {
        $cancelButton.show();
    });
    $searchField.keyup(function () {
        $cancelButton.toggle(Boolean($(this).val()));
        if ($searchField.val() && $searchField.val().length === 0) {
            $cancelButton.show();
        }
    });
    $cancelButton.toggle(Boolean($searchField.val()));
    $cancelButton.click(function () {
        $searchField.val('');
        $(this).hide();
    });
});
